/**
 * To avoid from being detected by react devtools
 */
export function disableReactDevtools() {
  if (
    window.__REACT_DEVTOOLS_GLOBAL_HOOK__ &&
    typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ === 'object'
  ) {
    Object
      .entries(window.__REACT_DEVTOOLS_GLOBAL_HOOK__)
      .forEach(([key, value]) => {
        window.__REACT_DEVTOOLS_GLOBAL_HOOK__[key] =
          typeof value === 'function' ? () => {} : null;
      });
  }
}
